import React from 'react';
import './SandboxBanner.css';

const SandboxBanner = () => {
    return (
        <div className="sandbox-banner">
            <div className="sandbox-banner-content">
                <span className="sandbox-icon">🧪</span>
                <span className="sandbox-text">
                    <strong>SANDBOX MODE</strong> - Testing Environment (Please do not add employees)
                </span>
                <span className="sandbox-icon">🧪</span>
            </div>
        </div>
    );
};

export default SandboxBanner;
